const module = { name: 'Fandango/popup', exports: {} }; const exports = module.exports;



import { Fandango_debugLog as debugLog } from '@grins/fd-modules/splits/onering-global';



const Styles = {
    HIDDEN: 'popup__lightbox--hidden',
    OPEN: 'popup__lightbox--open',
    MM_OPEN: 'popup__micromodal--open',
    OFFSCREEN: 'popup__lightbox--offscreen',
}


const DataAttribs = {
    INITIALIZED: 'initialized',
}


const Attribs = {
    CLOSE_TRIGGER: 'data-micromodal-close',
    HIDDEN: 'aria-hidden',
    ID: 'data-popup-id',
    INITIALIZED: 'data-initialized',
    TAB: 'tabindex',
}


const Selectors = {
    CLOSE: '.js-popup-close',
    OPEN_POPUP: `[${Attribs.ID}][${Attribs.INITIALIZED}][${Attribs.HIDDEN}=false]`,
    POPUP_PREFIX: 'popup$',
    FD_POPUP_PREFIX: 'fd-popup-'
}


const ANIMATION_LENGTH_DELAY = 450
function closePopup(popup) {
    popup.classList.remove(Styles.OPEN);
    popup.setAttribute(Attribs.TAB, -1);
    popup.setAttribute(Attribs.HIDDEN, true);
    setTimeout(() => {
        popup.classList.add(Styles.OFFSCREEN);
        popup.classList.add(Styles.HIDDEN);
    }, ANIMATION_LENGTH_DELAY);
}
function showPopup(popup) {
    popup.setAttribute(Attribs.TAB, 0);
    popup.setAttribute(Attribs.HIDDEN, false);
    popup.classList.remove(Styles.OFFSCREEN);
    popup.classList.add(Styles.OPEN);
}
function open(popup, onCloseCB) {
    popup.classList.remove(Styles.HIDDEN);
    window.MicroModal.show(popup.id, {
        awaitCloseAnimation: true,
        debugMode: false,
        disableScroll: true,
        onClose() {
            closePopup(popup);
            if (typeof onCloseCB === 'function') {
                onCloseCB(popup);
            }
        },
        onShow() {
            showPopup(popup);
        },
        openClass: Styles.MM_OPEN,
    });
    return popup;
}
function attach(selector, options) {
    const popup = selector && typeof selector === 'string' && document.querySelector(selector);
    if (!popup) {
        debugLog.error(module.name, 'attach invalid selector');
        return null;
    }
    if (popup.dataset[DataAttribs.INITIALIZED] === 'true') {
        return popup;
    }
    options = options || {};
    let closeSilent = false;
    popup.querySelectorAll(Selectors.CLOSE)
        .forEach((el) => {
        el.setAttribute(Attribs.CLOSE_TRIGGER, 'true');
        el.setAttribute(Attribs.ID, popup.id);
    });
    if (!popup.id) {
        popup.id = Selectors.POPUP_PREFIX + Date.now();
    }
    popup.setAttribute(Attribs.ID, popup.id);
    popup.setAttribute(Attribs.CLOSE_TRIGGER, 'true');
    popup.classList.add(Styles.HIDDEN);
    popup.close = () => {
        closeSilent = true;
        window.MicroModal.close(popup.id);
        return popup;
    };
    let onCloseCB;
    if (!closeSilent && typeof options.onClose === 'function') {
        onCloseCB = options.onClose;
    }
    popup.open = () => {
        open(popup, onCloseCB);
        return popup;
    };
    popup.dataset[DataAttribs.INITIALIZED] = 'true';
    return popup;
}
function showMessage(content, options, cb) {
    if (!content || typeof content !== 'string') {
        debugLog.error(module.name, 'showMessage invalid content string');
        return null;
    }
    if (arguments.length === 2 && typeof arguments[1] === 'function') {
        cb = arguments[1];
        options = {};
    }
    else {
        options = options || {};
    }
    const id = Selectors.FD_POPUP_PREFIX + Date.now();
    const container = document.createElement('div');
    container.innerHTML = '' +
        `<section id="${id}" class="popup__lightbox popup__lightbox--offscreen" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="popup">
    <button class="js-popup-close popup__close-btn-x" data-micromodal-close="true" data-popup-id="${id}">Dismiss</button>
    ${content}
  </div>
</section>`;
    if (!options.onClose && typeof cb === 'function') {
        options.onClose = cb;
    }
    document.body.appendChild(container.firstChild);
    const popup = attach('#' + id, options);
    if (!options.disableAutoShow) {
        popup.open();
    }
    return popup;
}
function getCurrent() {
    return document.querySelector(Selectors.OPEN_POPUP) || null;
}
function extendLegacy(area, publicInterface) {
    window.Fandango = window.Fandango || {};
    const { Fandango } = window;
    if (!Fandango[area]) {
        Fandango[area] = publicInterface;
    }
}
module.exports = {
    getCurrent,
    attach,
    showMessage,
};
extendLegacy('popup', module.exports);
export default module.exports;